export type Address = {
    firstName?: string | null;
    lastName?: string | null;
    company?: string | null;
    line1?: string | null;
    line2?: string | null;
    country?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    phoneNumber?: string | null;
    label?: string | null;
};

export type FieldName = keyof Address;

export type Options = Address & {
    field?: FieldName;
    fields?: FieldName[];
    allowPOBox?: boolean;
    allowLongUSZipCode?: boolean;
    isZipCodeRequired?: boolean;
    isPhoneRequired?: boolean;
    isCountryUS?: boolean;
    isLabelRequired?: boolean;
};

export type Message =
    | {
          defaultMessage: string;
          id: string;
      }
    | null
    | undefined;

const FIELDS: Record<string, FieldName> = {
    FIELD_FIRST_NAME: 'firstName',
    FIELD_LAST_NAME: 'lastName',
    FIELD_COMPANY: 'company',
    FIELD_LINE1: 'line1',
    FIELD_LINE2: 'line2',
    FIELD_COUNTRY: 'country',
    FIELD_CITY: 'city',
    FIELD_STATE: 'state',
    FIELD_ZIP_CODE: 'zipCode',
    FIELD_PHONE_NUMBER: 'phoneNumber',
    FIELD_LABEL: 'label',
};

const fields: FieldName[] = [
    FIELDS.FIELD_FIRST_NAME,
    FIELDS.FIELD_LAST_NAME,
    FIELDS.FIELD_COMPANY,
    FIELDS.FIELD_LINE1,
    FIELDS.FIELD_LINE2,
    FIELDS.FIELD_COUNTRY,
    FIELDS.FIELD_CITY,
    FIELDS.FIELD_STATE,
    FIELDS.FIELD_ZIP_CODE,
    FIELDS.FIELD_PHONE_NUMBER,
    FIELDS.FIELD_LABEL,
];

const optionalFields = [FIELDS.FIELD_COMPANY, FIELDS.FIELD_LINE2];

export const maxFieldLength = {
    FIRST_NAME: 40,
    LAST_NAME: 80,
};

export const regexMap = {
    specialCharacters: /[!@#$%^&*()+=><?]/,
    specialCharactersAddress: /[!@$%^&*()+=><?]/,
    poBox: /^.*P(\.|\s|OST)*O(\.|\s|FFICE)*b\s*o\s*x.*$/i,
    globalZipCode: /^(?!((\w|\s|-){1,9})$)/,
    usZipCode: /^(?!(\d{5}(?:[-\s]?\d{4})?$))/,
    usZipCodeShort: /^(?!(\d{5}?$))/,
    all: /^(?!(.*))/,
    // Phone numbers should have: digits, may have letters and can't have given special characters
    phoneNumber: /^(?=.*[\d+].*)[^!@#$%&^{}><~`=\[\]\|\\;'\/\?"±_§]+$/,
};

export default {
    FIELDS,
    fields,
    optionalFields,
    regexMap,
};
